/* eslint-disable */
// 分时数据
const state = {
  m_data: {
    data: [],
    yestclose: ''
  }
}

// getters
const getters = {
  m_data: state => state.m_data,
}

// actions
const actions = {
  
}

// mutations
const mutations = {
  setMData(state, data) {
    /*处理参数*/
    // 数据源
    let indata = [...data.data]
    const hqcConfig = JSON.parse(localStorage.getItem('hqcConfig'))
    const hqc = JSON.parse(JSON.stringify(hqcConfig))
    // console.log('接口hqc配置', hqc)
    // console.log('本地hqc配置', window.hqc)
    let configArr = null
    // 本地配置(原本写法)
    // let configArr = [...window.hqc]
    if (hqc && hqc.length) {
      // 接口有配置直接取接口返回的
      configArr = hqc
    } else if (window.hqc && window.hqc.length) {
      // 接口无配置 且 本地有配置 则 取本地配置
      configArr = [...window.hqc]
    } else {
      // 本地 和 接口 都无配置 则 为空数组
      configArr = []
    }
    // const targetAppNames = ['景陶易购', '贵茶茗汇', '茗贵e购', '楚云农商']
    // if (targetAppNames.includes(window.g.APP_WINNY_NAME)) {
    //   configArr = hqc
    // }
    // console.log('最终hqc配置', configArr)
    // 返回值
    let returnArr = []
    // 时间戳转小时:分钟
    let timestampToTime = function (timestamp) {
      const date = new Date(timestamp);
      const hours = "0" + date.getHours();
      const minutes = "0" + date.getMinutes();
      return hours.substr(-2) + ":" + minutes.substr(-2);
    }
    /**
     * 筛选交易节中的数据并返回
     * @param {window.hqc 交易节规则配置} config 
     * @param {ws接口接收到的行情数组} cDataArr 
     */
    let computeTradeDay = function (config, cDataArr) {
      let rArr = []
      let pushUni = false // 标记当前是否处于交易节中
      let isTimeCLick = false // 时间节点是否是交易节的开始或结束时刻,当为结束时刻,存储当前分时信息
      cDataArr.map((i) => {
        isTimeCLick = false
        let timestr = timestampToTime(i[0])
        config.tradeDay.map((j) => {
          if (j === timestr) {
            isTimeCLick = true
            pushUni = !pushUni
          }
        })
        if (pushUni || isTimeCLick) {
          rArr.push(i)
        }
      })
      return rArr
    }
    // 指示是否在配置中找到对应商品id
    let ishqc = false
    for (let i = 0; i < configArr.length; i++) {
      const element = configArr[i]
      if (hqProtocol.param_currencytimeline.contractId == element.symbolId) {
        ishqc = true
        // 匹配交易节规则,处理数组
        returnArr = computeTradeDay(element, indata)
      }
    }
    // 如果没有配置,默认添加全部行情返回数据
    if (!ishqc){
      state.m_data = data;
      return
    }

    if (returnArr.length === 0) {
      returnArr = data.data
    }
    data.data = returnArr
    state.m_data = data;
  },
  changeMData(state, data) {
    let md = JSON.parse(JSON.stringify(state.m_data))
    let ndArr = data.data
    ndArr.map((v, i) => {
      let md_index = null
      md.data.find((dv, di) => {
        if(v[0] === dv[0]) {
          md_index = di
          return di
        }
      })
      if(md_index !== null) {
        md.data[md_index] = v
      }
    })
    state.m_data = md
  },
  clearMData(state) {
    state.m_data = {
      data: [],
      yestclose: ''
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
